import React from "react";

const Ourfleets = () => {
const galleryData = [
  {
    id: 2,
    imgSrc: "/images/gallery/aura.jpg",
    title: "Hyundai Aura",
    description:
      "Hyundai Aura is a stylish compact sedan offering excellent mileage and a smooth, comfortable ride.",
    link: "/hyundai-aura",
  },
  // {
  //   id: 3,
  //   imgSrc: "/images/gallery/dzire.jpg",
  //   title: "Maruti Suzuki Dzire",
  //   description:
  //     "Maruti Suzuki Dzire is a reliable and fuel-efficient sedan ideal for city rides and outstation travel.",
  //   link: "/dzire",
  // },
  {
    id: 4,
    imgSrc: "/images/gallery/ertiga.jpg",
    title: "Maruti Suzuki Ertiga",
    description:
      "Maruti Suzuki Ertiga is a comfortable 7-seater MPV, perfect for family trips and long journeys.",
    link: "/ertiga",
  },
  {
    id: 5,
    imgSrc: "/images/gallery/17-seater-tempo-traveller.jpg",
    title: "17 Seater Tempo Traveller",
    description:
      "17 Seater Tempo Traveller is ideal for group tours, family functions, and comfortable group travel.",
    link: "/17-seater-tempo-traveller",
  },
  {
    id: 6,
    imgSrc: "/images/gallery/20-seater-tempo-traveller.jpg",
    title: "20 Seater Tempo Traveller",
    description:
      "20 Seater Tempo Traveller offers spacious seating and comfort for large group tours and outings.",
    link: "/20-seater-tempo-traveller",
  },
  {
    id: 7,
    imgSrc: "/images/gallery/urbania.jpg",
    title: "Force Urbania",
    description:
      "Force Urbania is a premium tempo traveller offering luxury seating and superior ride comfort.",
    link: "/force-urbania",
  },
  {
    id: 8,
    imgSrc: "/images/gallery/32-seater-bus.jpg",
    title: "32 Seater Bus",
    description:
      "32 Seater Bus is suitable for medium-sized groups, school trips, and corporate travel.",
    link: "/32-seater-bus",
  },
  {
    id: 9,
    imgSrc: "/images/gallery/35-seater-bus.jpg",
    title: "35 Seater Bus",
    description:
      "35 Seater Bus provides ample space and comfort for tours, events, and group transportation.",
    link: "/35-seater-bus",
  },
  {
    id: 10,
    imgSrc: "/images/gallery/40-seater-bus.jpg",
    title: "40 Seater Bus",
    description:
      "40 Seater Bus is ideal for large group travel, office outings, and long-distance tours.",
    link: "/40-seater-bus",
  },
  {
    id: 11,
    imgSrc: "/images/gallery/45-seater-bus.jpg",
    title: "45 Seater AC Bus",
    description:
      "45 Seater AC Bus offers maximum comfort for large groups, pilgrimage trips, and school tours.",
    link: "/45-seater-ac-bus",
  },
];



  return (
    <>

  <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Our Fleets
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>




      {/* Fleet Grid Section */}
      <section
        className="fleet-section section-padding"
        style={{ padding: "70px 0", background: "#f8fbff" }}
      >
        <div className="container">
          {/* <div className="text-center mb-5">
            <h2 className="fw-bold" style={{ color: "#F26722" }}>
              Our Premium Fleet Collection
            </h2>
            <p style={{ color: "#555", fontSize: "17px" }}>
              Explore our modern, well-maintained vehicles offering comfort,
              safety, and reliability for every journey.
            </p>
          </div> */}

          <div className="row g-4">
            {galleryData.map((item) => (
              <div key={item.id} className="col-xl-4 col-md-6 col-12">
                <div
                  className="fleet-card shadow-lg border-0 rounded-4"
                  style={{
                    background: "#fff",
                    transition:
                      "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="fleet-image position-relative"
                    style={{
                      overflow: "hidden",
                      borderTopLeftRadius: "1rem",
                      borderTopRightRadius: "1rem",
                    }}
                  >
                    <img
                      src={item.imgSrc}
                      alt={item.title}
                      className="img-fluid w-100"
                      style={{
                        height: "220px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                    />
                  </div>

                  <div className="fleet-content p-4 text-center">
                    <h4 style={{ color: "#F26722", fontWeight: "600" }}>
                      {item.title}
                    </h4>
                    <p
                      style={{
                        color: "#444",
                        fontSize: "15px",
                        lineHeight: "1.6",
                        minHeight: "90px",
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Ourfleets;
